import ListCardBadge from './ListCardBadge.vue';

export * from './types';
export default ListCardBadge;



// WEBPACK FOOTER //
// ./src/uikit/components/ListCardBadge/index.ts